import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import "bootstrap/js/dist/dropdown";
import Forms from './components/forms';
import Recommendations from './components/recommendations';
import Nav from './components/navigation';
import animatedTitle from './components/animatedTitle';
import swapMobileImages from './components/textImage';
import { servicesSlider, packagesSlider, testimonialsSlider } from './components/sliders';

class App {
  static init() {
    (new Nav()).init();
    (new Forms()).init();
    (new Recommendations().init());
    testimonialsSlider();
    packagesSlider();
    servicesSlider();
    animatedTitle();
    swapMobileImages();

    $('.btn-read-more').on('click', (e) => {
      e.preventDefault();
      const $button = $(e.currentTarget);
      $button.parents('.wysiwyg').find('.read-more-content').slideToggle();
      setTimeout(() => $button.hide(), 200);
    });
  }
}

App.init();

